module.exports = __webpack_public_path__ + "img/selected2-min.58f16dca.png";